
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_fvjdu_21gvo_145",
  "button": "awsui_button_fvjdu_21gvo_185",
  "dots": "awsui_dots_fvjdu_21gvo_186",
  "button-disabled": "awsui_button-disabled_fvjdu_21gvo_214",
  "arrow": "awsui_arrow_fvjdu_21gvo_219",
  "page-number": "awsui_page-number_fvjdu_21gvo_229",
  "button-current": "awsui_button-current_fvjdu_21gvo_235",
  "page-item": "awsui_page-item_fvjdu_21gvo_252",
  "root-disabled": "awsui_root-disabled_fvjdu_21gvo_270"
};
  